import Marionette from 'backbone.marionette';
import billDetailStatusItemviewTmpl from '../templates/bill_detail_status_itemview.tpl';
export default Marionette.ItemView.extend({
  template: billDetailStatusItemviewTmpl,
  tagName: "tr"
  // className: ""
});